import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getOrdersService } from "redux/services/orders_service";

const FiltersBar = ({ searchTerm, setSearchTerm }) => {

  const {t} = useTranslation();

  const { metaOrders } = useSelector((state) => state.orders);

  const dispatch = useDispatch();

  const [filter, setFilter] = useState("all");
  const filters = [
    { id: "all", label: "All" },
    { id: "not_confirmed", label: "not_confirmed" },
    { id: "in_progress", label: "processing" },
    { id: "shipped", label: "shipped" },
    { id: "canceled", label: "cancelled" },
    { id: "delivered", label: "delivered" },
  ];

  useEffect(() => {
    // إذا الفلتر "all" نرسل status فارغ أو لا نرسل status حسب API
    const status = filter === "all" ? undefined : filter;
    dispatch(
      getOrdersService({
        page: 1,
        ...(status ? { status } : {}),
      })
    );
  }, [filter, dispatch]);

  return (
    <div className="flex flex-wrap items-center justify-between mb-4 gap-4">
      {/* Filters */}
      <div>
        {filters.map(({ id, label }) => (
          <button
            key={id}
            className={`px-4 py-1 rounded-md text-sm font-medium ${
              filter === id
                ? "bg-green-200 text-green-800"
                : "text-green-600 hover:bg-green-200"
            }`}
            onClick={() => setFilter(id)}
          >
            {t(label)}{" "}
            {id === "all" && (
              <span className="ml-1">({metaOrders?.total})</span>
            )}
          </button>
        ))}
      </div>

      {/* Search and actions 
      <div className="flex items-center space-x-2">
        <div className="relative">
          <input
            type="text"
            placeholder="Search order report"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="border border-gray-300 rounded-md pl-10 pr-3 py-2 text-sm focus:outline-green-500"
          />
          <svg
            className="w-5 h-5 text-gray-400 absolute left-3 top-2.5 pointer-events-none"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M21 21l-4.35-4.35M17 11a6 6 0 11-12 0 6 6 0 0112 0z"
            />
          </svg>
        </div>
        <button className="border border-gray-300 rounded-md px-3 py-2 hover:bg-gray-100">
         
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2a1 1 0 01-.293.707L14 14v5a1 1 0 01-2 0v-5L3.293 6.707A1 1 0 013 6V4z"
            />
          </svg>
        </button>
        <button className="border border-gray-300 rounded-md px-3 py-2 hover:bg-gray-100">
         
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M3 9l6 6 6-12"
            />
          </svg>
        </button>
        <button className="border border-gray-300 rounded-md px-3 py-2 hover:bg-gray-100">
         
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path d="M6 10a2 2 0 11-4 0 2 2 0 014 0zm6-2a2 2 0 100 4 2 2 0 000-4zm6 2a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
        </button>
      </div>*/}
    </div>
  );
};

export default FiltersBar;
